<ps-ui-modal
  class="quota-modal quota-nested-modal"
  (closeIntercepted)="discardChanges()"
>
  <ps-ui-modal-body class="pt-0">
    <h2 class="text-center">Quota Nesting</h2>

    <section class="alerts mt-3">
      <ng-container *ngFor="let alert of alerts$ | async">
        <ng-template [ngIf]="alert.visible">
          <ps-ui-alert
            [message]="alert.message"
            [type]="alert.type"
          ></ps-ui-alert>
        </ng-template>
      </ng-container>
    </section>

    <section class="content mt-2">
      <div class="quota-nesting-selection">
        <div class="scroll-container nesting-selection">
          <ps-ui-multi-quota-nesting-selection
            [originalQuotas]="originalQuotas"
            [surveyAllocation]="surveyAllocation"
          ></ps-ui-multi-quota-nesting-selection>
        </div>

        <div
          *ngIf="selectedNestingGroup$ | async as selectedNestingGroup"
          class="nesting-button me-2"
        >
          <button
            type="button"
            class="btn btn-primary w-100 mt-3"
            [disabled]="
              pendingNestingGroup &&
              (selectedNestingGroup.state === 'created' ||
                !selectedNestingGroup.selectedQualifications.length)
            "
            (click)="
              pendingNestingGroup
                ? createAnotherNesting(selectedNestingGroup)
                : addNewNestingGroupWithEmptyState()
            "
          >
            Create Another Nesting +
          </button>
        </div>
      </div>
      <ps-ui-multi-quota-nesting-table
        class="quota-nesting-table"
        [originalQuotas]="originalQuotas"
        [surveyAllocation]="surveyAllocation"
        [buyerCompanyId]="buyerCompanyId"
      ></ps-ui-multi-quota-nesting-table>
    </section>

    <section class="footer-section">
      <button
        psUiButton
        type="button"
        color="primary"
        class="save-btn"
        [disabled]="!hasUnsavedChanges"
        (click)="saveChanges()"
      >
        Save
      </button>
    </section>
  </ps-ui-modal-body>
</ps-ui-modal>
